import { WebinarSession } from "../types/models";
import { copyToClipboard } from "./copyToClipboard";
import { sessionWhenParts } from "./deriveStartAt";

export const buildWebinarShareMessage = (
  sessionName: string,
  expertName: string,
  description: string,
  sessionDate: string,
  sessionTime: string,
  sessionLink: string,
) =>
  `Hey! 👋\nI’m joining this GoodFlip live session: “${sessionName}” with ${expertName}.\nIt’s about ${description}.\n\nThought you might find it useful too!\n\nDate: ${sessionDate}\nTime: ${sessionTime}\n\nJoin here: ${sessionLink}`;

export const buildWebinarDetailDeepLink = (sessionId: string) => {
  const deepLinkValue = encodeURIComponent(
    `https://webinar-detail/${sessionId}`,
  );
  return (
    "https://link.goodflip.in/d/UTJ0PrPwYo" +
    "?pid=Social_facebook&cost_value=0&cost_currency=INR&lbw=1d" +
    "&camp=webinar-detail" +
    `&dlv=${deepLinkValue}` +
    `&deepLinkValue=${deepLinkValue}`
  );
};

export function resolveWebinarShareLink(session: WebinarSession): string {
  const fromApi = session.shortDeepLink?.trim();
  if (fromApi) return fromApi;
  return buildWebinarDetailDeepLink(session.id);
}

export function formatWebinarShareMessage(session: WebinarSession): string {
  const when = sessionWhenParts(session.start, session.mins);
  const timeOnly = when.timeLine.split(" · ")[0] || when.timeLine;
  return buildWebinarShareMessage(
    session.title || "Live session",
    session.hostName || "GoodFlip host",
    session.oneLiner || session.fullDesc || "a live health session",
    when.dateLine,
    timeOnly,
    resolveWebinarShareLink(session),
  );
}

/**
 * Share app deep-link message via Web Share API when available,
 * otherwise copy to clipboard.
 */
export async function shareWebinarSession(
  session: WebinarSession,
): Promise<"shared" | "copied" | "cancelled" | "failed"> {
  const text = formatWebinarShareMessage(session);
  const shareData = {
    title: session.title || "GoodFlip live session",
    text,
  };

  try {
    if (
      typeof navigator.share === "function" &&
      (!navigator.canShare || navigator.canShare(shareData))
    ) {
      await navigator.share(shareData);
      return "shared";
    }
  } catch (e) {
    // User cancelled share sheet — not a failure to surface as error.
    if (e instanceof DOMException && e.name === "AbortError") {
      return "cancelled";
    }
  }

  const ok = await copyToClipboard(text);
  return ok ? "copied" : "failed";
}
